export const setUserField = (field, value) => ({
  type: "SET_USER_FIELD",
  field,
  value,
});

export const setCompanyField = (field, value) => ({
  type: "SET_COMPANY_FIELD",
  field,
  value,
});


export const resetSubscription = () => ({
  type: "RESET_SUBSCRIPTION",
});
